import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-hero-section",
    templateUrl: "./hero-section.component.html",
    styleUrl: "./hero-section.component.scss",
    standalone: false,
})
export class HeroSectionComponent {
    herosData: { title: string; subtitle: string; subtitle2: string; image: string }[] = [
        {
            title: "Design Your Imagination",
            subtitle:
                "Discover endless possibilities with thoughtfully crafted blocks and a Design Studio that lets you create, customize, and bring your ideas to life — one meaningful build at a time.",
            subtitle2: "Not just toys — timeless experiences.",
            image: "../../../assets/images/block.png",
        },
        {
            title: "Where Imagination Takes Shape",
            subtitle:
                "Explore a world of blocks designed to be imagined, customized, and built your way — turning play into creativity, connection, and joy at every age.",
            subtitle2: "Because creativity never grows old.",
            image: "../../../assets/images/block2.png",
        },
        {
            title: "Your Imagination. Your Design Studio.",
            subtitle:
                "Create with purpose using premium blocks you can customize in color, shape, and pattern — because the most powerful play is the one you design yourself",
            subtitle2: "Every block holds a feeling.",
            image: "../../../assets/images/block3.png",
        },
    ];

    private interval: ReturnType<typeof setTimeout> | null = null;

    public currentIndex = 0;

    constructor(private router: Router) {}

    ngOnInit(): void {
        this.startCarousel();
    }

    ngOnDestroy(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    private startCarousel(): void {
        this.interval = setInterval(() => {
            this.nextSlide();
        }, 5000);
    }

    public nextSlide(): void {
        this.currentIndex = (this.currentIndex + 1) % this.herosData.length;
    }

    public prevSlide(): void {
        this.currentIndex = (this.currentIndex - 1 + this.herosData.length) % this.herosData.length;
    }

    public goToSlide(index: number): void {
        this.currentIndex = index;
    }

    public navigateDesigner(): void {
        this.router.navigate(["/designer"]);
    }

    public navigateProductPage(): void {
        this.router.navigate(["/products"]);
    }
}
